import React from 'react';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { useRoutes } from 'react-router-dom';
import routes from './routes';
import customTheme from './theme';
import { useSelector } from 'react-redux';

function App() {
  const { userToken, userInfo, isAssumed, assumedUserInfo } = useSelector(
    state => state.user
  );
  const routing = useRoutes(
    routes({ isAuth: userToken ? true : false, userInfo, isAssumed, assumedUserInfo })
  );
  const theme = extendTheme(customTheme);

  return <ChakraProvider theme={theme}>{routing}</ChakraProvider>;
}

export default App;
